<template>
  <div class="permission-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('edit') }}</strong>
              <div class="card-actions">
              </div>
            </div>
            <b-form class="row" v-if="item.uuid != null">

              <b-col cols="9" align-self="center">
                <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.name" aria-describedby="nameFeedback">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('description')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.description">
                  </b-form-input>
                </b-form-group>
                <b-form-group v-bind:label="$t('code')" :label-cols="3" :horizontal="true">
                  <b-form-input class="form-control" v-model="item.code">
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col cols="12"><hr/></b-col>

              <b-col cols="12">
                <b-card>
                  <div slot="header">
                    {{$t('config')}}
                    <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateConfigStatus" v-b-toggle.config_content>
                      <i class="fa fa-chevron-up" v-if="configStatus == 1"></i>
                      <i class="fa fa-chevron-down" v-if="configStatus == 0"></i>
                    </label>
                  </div>

                  <b-collapse id="config_content">
                    <b-row v-for="(config, c) in item.configs" :key="config.id">
                      <b-col>
                        <b-form-group v-bind:label="$t('group')" :label-cols="3" :horizontal="true">
                          <b-form-input class="form-control" v-model="config.group">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group v-bind:label="$t('key')" :label-cols="3" :horizontal="true">
                          <b-form-input class="form-control" v-model="config.key">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group v-bind:label="$t('value')" :label-cols="3" :horizontal="true">
                          <b-form-input class="form-control" v-model="config.value">
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="1">
                        <b-button variant="danger" v-on:click="removeConfig(c)"><i class="fa fa-trash-o"></i></b-button>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-button variant="success" v-on:click="addConfig"><i class="fa fa-plus"></i>&nbsp; {{$t('config')}}</b-button>
                      </b-col>
                    </b-row>
                  </b-collapse>

                </b-card>
              </b-col>

              <b-col cols="12"><hr/></b-col>

              <b-col cols="12">
                <b-card>
                  <div slot="header">
                    {{$t('customizes')}}
                    <label class="switch switch-sm switch-text switch-info float-right mb-0" @click="updateCustomizeStatus" v-b-toggle.customize_content>
                      <i class="fa fa-chevron-up" v-if="customizeStatus == 1"></i>
                      <i class="fa fa-chevron-down" v-if="customizeStatus == 0"></i>
                    </label>
                  </div>

                  <b-collapse id="customize_content">
                    <b-row v-for="(customize, c) in item.customizes" :key="customize.id">
                      <b-col cols="3">
                        <b-form-group v-bind:label="$t('group')" :label-cols="3" :horizontal="true">
                          <b-form-select :options="groups" v-model="item.customizes[c].group"></b-form-select>
                        </b-form-group>
                        <b-button variant="danger" v-on:click="removeGroup(c)"><i class="fa fa-minus"></i>&nbsp; {{$t('group')}}</b-button>
                      </b-col>
                      <b-col cols="9">
                        <b-row v-for="(field, f) in item.customizes[c].fields" :key="field.id">
                          <b-col cols="6">
                            <b-form-group v-bind:label="$t('name')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].name">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6">
                            <b-form-group v-bind:label="$t('tag')" :label-cols="3" :horizontal="true">
                              <b-form-select :options="tags" v-model="item.customizes[c].fields[f].tag" @change="updateTag (c, f)"></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'text_box'">
                            <b-form-group v-bind:label="$t('type')" :label-cols="3" :horizontal="true">
                              <b-form-select :options="types" v-model="item.customizes[c].fields[f].attribute.type"></b-form-select>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6">
                            <b-form-group v-bind:label="$t('class')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.class">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'date_box'">
                            <b-form-group v-bind:label="$t('default')" :label-cols="3" :horizontal="true">
                              <masked-input
                                type="text"
                                name="date"
                                class="form-control"
                                v-model="item.customizes[c].fields[f].attribute.default"
                                :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                :guide="true"
                                placeholderChar="_"
                                :showMask="true"
                                :keepCharPositions="true">
                              </masked-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'text_box'">
                            <b-form-group v-bind:label="$t('default')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.default">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'text_box' || item.customizes[c].fields[f].tag == 'text_area'">
                            <b-form-group v-bind:label="$t('place_holder')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.place_holder">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'switch'">
                            <b-form-group v-bind:label="$t('check_value')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.check_value">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'switch'">
                            <b-form-group v-bind:label="$t('uncheck_value')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.uncheck_value">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'text_area'">
                            <b-form-group v-bind:label="$t('rows')" :label-cols="3" :horizontal="true">
                              <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.rows">
                              </b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col cols="6" v-if="item.customizes[c].fields[f].tag == 'select'">
                            <b-form-group v-bind:label="$t('multiple')" :label-cols="3" :horizontal="true">
                              <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" v-model="item.customizes[c].fields[f].attribute.multiple" v-bind:checked="item.customizes[c].fields[f].attribute.multiple" :value="1" :uncheckedValue="0"/>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12" v-if="item.customizes[c].fields[f].tag == 'select' || item.customizes[c].fields[f].tag == 'check_box' || item.customizes[c].fields[f].tag == 'radio_group'">
                            <b-form-group v-bind:label="$t('options')" :label-cols="2" :horizontal="true">
                              <table class="table">
                                <thead>
                                <tr>
                                  <th>{{$t('text')}}</th>
                                  <th>{{$t('value')}}</th>
                                  <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(option, o) in item.customizes[c].fields[f].attribute.options" :key="option.id">
                                  <td>
                                    <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.options[o].text">
                                    </b-form-input>
                                  </td>
                                  <td>
                                    <b-form-input class="form-control" v-model="item.customizes[c].fields[f].attribute.options[o].value">
                                    </b-form-input>
                                  </td>
                                  <td>
                                    <b-button size="sm" variant="danger" v-on:click="removeOption(c, f, o)"><i class="fa fa-minus"></i></b-button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    <b-button size="sm" variant="success" v-on:click="addOption(c, f)"><i class="fa fa-plus"></i></b-button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </b-form-group>
                          </b-col>
                          <b-col cols="12">
                            <b-button variant="danger" v-on:click="removeField(c, f)"><i class="fa fa-minus"></i>&nbsp; {{$t('field')}}</b-button>
                          </b-col>
                          <b-col cols="12">
                            <div class="clearfix"><hr/></div>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12">
                            <b-button variant="success" v-on:click="addField(c)"><i class="fa fa-plus"></i>&nbsp; {{$t('field')}}</b-button>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col cols="12">
                        <div class="clearfix"><hr/></div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <b-button variant="success" v-on:click="addGroup"><i class="fa fa-plus"></i>&nbsp; {{$t('group')}}</b-button>
                      </b-col>
                    </b-row>
                  </b-collapse>

                </b-card>
              </b-col>
            </b-form>
            <div slot="footer" class="text-center">
              <router-link :to="{name: model + '_list'}"><b-button variant="default"><i class="fa fa-arrow-left"></i> {{$t('back')}}</b-button></router-link>
              <b-button variant="success" v-on:click="updateItem" v-if="uuid != null && $auth.check(model + '.update')"><i class="fa fa-save"></i> {{$t('update')}}</b-button>
              <b-button variant="success" v-on:click="createItem" v-if="uuid == null && $auth.check(model + '.create')"><i class="fa fa-save"></i> {{$t('save')}}</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .switch {
    margin-bottom: 0px;
    margin-top: 7px;
    float: left;
    margin-right: 5px;
  }
</style>
<script>
  import {get, create, update} from '@/api/client'
  import cSwitch from '../../../components/Switch'
  import MaskedInput from 'vue-text-mask'

  export default {
    name: 'PermissionForm',
    props: {
      uuid: {
        type: String,
        default: null
      }
    },
    components: {
      MaskedInput,
      cSwitch
    },
    computed: {
    },
    data: function () {
      return {
        model: 'client',
        item: {
          uuid: null,
          name: '',
          description: '',
          code: '',
          configs: [],
          customizes: []
        },
        configStatus: 0,
        customizeStatus: 0,
        groups: [
          {text: 'Customer', value: 'customer'},
          {text: 'Product', value: 'product'},
          {text: 'Store', value: 'store'}
        ],
        tags: [
          {text: 'Text Box', value: 'text_box'},
          {text: 'Check Box', value: 'check_box'},
          {text: 'Radio Group', value: 'radio_group'},
          {text: 'Select', value: 'select'},
          {text: 'Switch', value: 'switch'},
          {text: 'Text Area', value: 'text_area'},
          {text: 'Date Box', value: 'date_box'}
        ],
        types: [
          {text: 'Text', value: 'text'},
          {text: 'Number', value: 'number'}
        ],
        option: {
          text: '',
          check_value: '',
          uncheck_value: ''
        },
        attributes: {
          text_box: {
            type: 'text',
            class: '',
            default: '',
            place_holder: ''
          },
          check_box: {
            class: '',
            options: [],
            default: ''
          },
          radio_group: {
            class: '',
            options: [],
            default: ''
          },
          select: {
            class: '',
            multiple: false,
            options: [],
            default: ''
          },
          switch: {
            class: '',
            check_value: '',
            uncheck_value: '',
            default: ''
          },
          text_area: {
            class: '',
            rows: 5,
            uncheck_value: '',
            default: '',
            place_holder: ''
          },
          date_box: {
            class: '',
            default: this.$moment().format('DD/MM/YYYY')
          }
        },
        languages: Object.keys(this.$i18n.messages)
      }
    },
    methods: {
      /**
       * Update attribute of tag in group
       * @param group index
       * @param field index
       */
      updateTag (group, field) {
        let tag = this.item.customizes[group].fields[field].tag
        let c = setInterval(() => {
          if (tag != this.item.customizes[group].fields[field].tag) {
            this.item.customizes[group].fields[field].attribute = this._.cloneDeep(this.attributes[this.item.customizes[group].fields[field].tag])
            clearInterval(c)
          }
        }, 100)
      },
      /**
       * Remove option attribute of field in group
       * @param group index
       * @param field index
       * @param option index
       */
      removeOption (group, field, option) {
        let options = []
        for (let i in this.item.customizes[group].fields[field].attribute.options) {
          if (i != option) {
            options.push(this.item.customizes[group].fields[field].attribute.options[i])
          }
        }
        this.item.customizes[group].fields[field].attribute.options = options
      },
      /**
       * Add option to field of group
       * @param group index
       * @param field index
       */
      addOption (group, field) {
        console.log(this.item.customizes[group].fields[field].attribute)
        this.item.customizes[group].fields[field].attribute.options.push({
          text: '',
          value: ''
        })
      },
      /**
       * Remove field of group
       * @param group index
       * @param field index
       */
      removeField (group, field) {
        let fields = []
        for (let i in this.item.customizes[group].fields) {
          if (i != field) {
            fields.push(this.item.customizes[group].fields[i])
          }
        }
        this.item.customizes[group].fields = fields
      },
      /**
       * Add field to group
       * @param group index
       */
      addField (group) {
        this.item.customizes[group].fields.push({
          tag: 'text_box',
          name: '',
          attribute: this._.cloneDeep(this.attributes.text_box)
        })
      },
      /**
       * Remove group
       * @param index of group
       */
      removeGroup (index) {
        let customizes = []
        for (let i in this.item.customizes) {
          if (i != index) {
            customizes.push(this.item.customizes[i])
          }
        }
        this.item.customizes = customizes
      },
      /**
       * Add group
       */
      addGroup () {
        this.item.customizes.push({
          group: '',
          fields: []
        })
      },
      /**
       * Remove config
       * @param index of config
       */
      removeConfig (index) {
        let configs = []
        for (let i in this.item.configs) {
          if (i != index) {
            configs.push(this.item.configs[i])
          }
        }
        this.item.configs = configs
      },
      /**
       * Add config
       */
      addConfig () {
        this.item.configs.push({
          group: '',
          key: '',
          value: ''
        })
      },
      /**
       * Update status of config session
       */
      updateConfigStatus () {
        if (this.configStatus == 0) {
          this.configStatus = 1
        } else {
          this.configStatus = 0
        }
      },
      /**
       * Update status of customize session
       */
      updateCustomizeStatus () {
        if (this.customizeStatus == 0) {
          this.customizeStatus = 1
        } else {
          this.customizeStatus = 0
        }
      },
      /**
       * Get details of object
       */
      getDetails () {
        this.$Progress.start()
        let data = {
          uuid: this.uuid
        }
        get(data).then((response) => {
          response.data.data.customizes = []
          this.item = response.data.data
          let customizes = []
          this.item.customizes = []

          for (let i in response.data.data.customize_fields) {
            let customize = response.data.data.customize_fields[i]
            if (customizes[customize.group] == null) {
              customizes[customize.group] = {
                group: customize.group,
                fields: []
              }
            }
            customizes[customize.group].fields.push({
              tag: customize.tag,
              name: customize.name,
              attribute: customize.attribute
            })
          }

          for (let i in customizes) {
            this.item.customizes.push(customizes[i])
          }
        }).catch((error) => {
          this.$notify({
            title: this.$t('error'),
            text: error.data.message,
            type: 'error'
          })
        }).then(() => {
          this.$Progress.finish()
        })
      },
      /**
       * Update item info to server
       */
      updateItem () {
        this.$Progress.start()
        update(this.item).then((response) => {
            this.$Progress.finish()
            this.$notify({
              title: this.$t('success'),
              text: response.data.message,
              type: 'success'
            })
            this.$router.push({name: this.model})
          }).catch((error) => {
            this.$notify({
              title: this.$t('error'),
              text: error.data.message,
              type: 'error'
            })
          }).then(() => {
            this.$Progress.finish()
          })
      },
      /**
       * Create item info to server
       */
      createItem () {
        this.$Progress.start()
        create(this.item).then((response) => {
            this.$notify({
              title: this.$t('success'),
              text: response.data.message,
              type: 'success'
            })
            this.$router.push({name: this.model})
          }).catch((error) => {
            this.$notify({
              title: this.$t('error'),
              text: error.data.message,
              type: 'error'
            })
          }).then(() => {
          this.$Progress.finish()
        })
      }
    },
    created: function () {
      if (this.uuid != null) {
        this.getDetails()
      } else {
        this.item.uuid = ''
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/client/Form.vue